import { defineStore } from 'pinia'

export interface ViewState {
  layout: {
    leftDrawer: {
      open: boolean
      width: number
    }
  }
  isLoading: boolean
}

export interface IAppState {
  tablePerPage: number
  minimumSupportedAppVersion: number | null
}

export const useAppStore = defineStore('pinia/app', {
  state: () =>
    ({
      layout: {
        leftDrawer: {
          open: true,
          width: 57, // This is not dynamic yet, just used as a constant for now
        },
      },
      isLoading: false,
      tablePerPage: 500,
      minimumSupportedAppVersion: null,
    } as IAppState & ViewState),
  actions: {
    toggleLeftDrawer() {
      this.layout.leftDrawer.open = !this.layout.leftDrawer.open
    },
    setLoading(isLoading: boolean) {
      this.isLoading = isLoading
    },
    setMinimumSupportedAppVersion(minimumSupportedAppVersion: number | null) {
      this.minimumSupportedAppVersion = minimumSupportedAppVersion
    },
  },
})
